export default "/static/assets/social-profile.032b7ec46ab98c7133375d063590086a.svg";